/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */
// import PropTypes from "prop-types";

import React, { useContext, useState } from "react";
import Img from "gatsby-image";
import BlockContent from "@sanity/block-content-to-react";
import { getFluidGatsbyImage } from "gatsby-source-sanity";
import { DocumentContext } from "~context/DocumentContext";

const PortableText = ({ blocks }) => {
  const { device } = useContext(DocumentContext);

  const sanityConfig = { projectId: `ycuu4h2c`, dataset: `production` };

  const [serializers, setSerializers] = useState({
    types: {
      block: props => {
        switch (props.node.style) {
          case `h1`:
            return (
              <h1 className="mt-12 md:mt-8 mb-3 md:mb-6 f1">
                {props.children}
              </h1>
            );

          case `h2`:
            return (
              <h2 font="2" className="mt-12 md:mt-8 mb-3 md:mb-6 f2">
                {props.children}
              </h2>
            );

          case `h3`:
            return (
              <h3 font="3" className="mt-12 md:mt-8 mb-3 md:mb-6 f3">
                {props.children}
              </h3>
            );

          case `h4`:
            return (
              <h4 font="4" className="mt-12 md:mt-8 mb-3 md:mb-6 f4">
                {props.children}
              </h4>
            );

          case `h5`:
            return (
              <h5 font="5" className="mt-12 md:mt-8 mb-3 md:mb-6 h1">
                {props.children}
              </h5>
            );

          case `h6`:
            return (
              <p font="1" className="mt-12 md:mt-8 mb-3 md:mb-6 h2" serif>
                {props.children}
              </p>
            );

          case `normal`:
            return <p className="mb-4 md:mb-2 b1">{props.children}</p>;

          default:
            return <></>;
        }
      },
      altImage: props => {
        const fluidProps = getFluidGatsbyImage(
          props.node.asset._ref,
          { maxWidth: 800 },
          sanityConfig
        );
        return (
          <Img
            className="grid-end-12 relative block"
            fluid={fluidProps}
            alt={props.node.altText}
          />
        );
      }
    }
  });

  //

  return (
    <BlockContent
      className="portable-text"
      blocks={blocks}
      serializers={serializers}
    />
  );
};

export default PortableText;
